const deleteInvite = inviteRef => {
  return inviteRef
    .delete()
}

export default deleteInvite
